(function(){
    angular
        .module('app')
        .directive('ngInfopeti', extrapeti);

        extrapeti.$inject = ['AnalisisService','$timeout','GenerallabService'];
        function extrapeti(AnalisisService,$timeout,GenerallabService){
            return {
            	restrict:'E',
		        scope: {
		          	pet:'=',
		          	appvm:'='
		          	//muestra:"="
	            },
	           	template: '<div ng-include="getTemplateUrl()"></div>',

	            /*templateUrl: function(element,$attrs){
	            	console.log($attrs);
	            	return '/uranolab/extrapeti?lang_id='+lang_id+"&form="+$attrs.formulario+"[[formulario]]";
	            },*/
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	scope.generalService = GenerallabService;
		            	scope.parent = scope.$parent;
		            	
		            	console.log("infopet",scope);
		            	
		            	scope.getTemplateUrl = function () {
	            			return '/uranolab/extrapet?lang_id='+lang_id;
			            }


			           
			            scope.addTratamiento = function(){
			            	console.log("pet",scope.pet);
			            	if(angular.isUndefined(scope.pet.fields.extra.tratamientos)){
				                scope.pet.fields.extra.tratamientos = [];
				            }
					        scope.pet.fields.extra.tratamientos.push({tratamiento:"",respuesta:""});
					    }

					    scope.eliminarTratamiento = function(index){
					    	scope.pet.fields.extra.tratamientos.splice(index,1);
					    }
					    scope.getMuestrasRelacionadas = function(muestras){
					    	console.log("muestras",muestras);
			            	var muestrasFinal = [];
			            	for(var cont=0;cont<muestras.length;cont++){
			            		var lims_id = (muestras[cont].lims_id ? muestras[cont].lims_id : muestras[cont].id);
			            		var analiticas = [];
			            		for(var cont2=0;cont2<muestras[cont].analiticas.length;cont2++){
			            			if(angular.isDefined(muestras[cont].analiticas[cont2].analiticas)){
				            			for(var cont3=0;cont3<muestras[cont].analiticas[cont2].analiticas.length;cont3++){
				            				analiticas.push(muestras[cont].analiticas[cont2].analiticas[cont3].nombre);
				            			}
				            		}
			            		}

			            		muestrasFinal.push({lims_id:lims_id,text:lims_id+" ("+analiticas.join(",")+")"});
			            	}
			            	scope.pet.animalSeleccionado.muestrasFinal = muestrasFinal;
			            }
		            });
		        }
          }
      	}
})();